// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__firez","placeholderShimmer":"Skeleton_placeholderShimmer__ea6r4","darkSkeleton":"Skeleton_darkSkeleton__KeBxx"};